// extracted by mini-css-extract-plugin
export var eyebrow = "searchHero-module--eyebrow--03431";
export var headline = "searchHero-module--headline--b53e8";
export var searchBox = "searchHero-module--searchBox--32bd2";
export var searchHero = "searchHero-module--searchHero--56fa3";
export var searchHeroContent = "searchHero-module--searchHeroContent--6e4b3";
export var subheadline = "searchHero-module--subheadline--9f1c1";